// Copyright (c) 2024 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useCallback, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { Col, Row, Container, Form, ListGroup, Image } from 'react-bootstrap'
import { EMPTY_ARRAY, EMPTY_OBJECT, getSvgIcon, getWalletScriptUrl } from '../../constants/globalConstants'
import debounce from 'lodash/debounce'

// import down from '../../assets/img/download.png'

import { useParams, useNavigate } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css'
import './Extend.scss'
import { getRateDetailsData, getRateHourData, postExtendData } from '../../redux/actions/ExtendFromAction'
import URL from '../../constants/urls'
import Loader from '../../global/Loader'
import {
    checkEstimateTime,
    // convertTimeToDoubleDig,
    encryptionHandler, getCardIcon, getConvertedDate, getDeviceType, getHoursForRateBand, getHoursIndayFormat, isExtendButton, isPermissionExist, isPromoValidateButton, loggedInUserData, priceGreaterOrNot, showhideWalletButton, sortPortalPermissionByKey, TimeConversion, TimeConversionInHours, timeValidationConversion,
    paybyCardorWallet, navigateToHomeScreen, formatExpiryDate
} from '../../utils/helper'
import MiniHeader from '../../components/global/MiniHeader'
import Footer from '../../components/global/Footer'
import { errorMessage, paymentStoppedmsg } from '../../constants/errorMessage'
import { endParking, fetchRateBands, fetchRateDetailData } from '../../redux/actions/transientAction'
import ConfirmationModal from '../../global/ConfirmationModal'
import UpperHeader from '../../components/global/UpperHeader'
// import ListingDataComp from '../../components/global/ListingDataComp'
import AmountPaid from '../../components/global/AmountPaid'
import ClockTimer from '../../components/global/ClockTimer'
import ExtendEndButton from '../../components/global/ExtendEndButton'
import QRCodeComp from '../../components/global/QRCode'
import NoData from '../../components/NoData'
import PaymentBreakUpDetails from '../../components/global/PaymentBreakUpDetails'
import ReactMobiltySpinner from '../../global/ReactMobiltySpinner'
// import { getPartnerDetailsBySLug } from '../../redux/actions/userDetails'
import moment from 'moment-timezone'
import ScrollCalendar from '../scrollCalendar/ScrollCalendar'
import { getCardLists } from '../../redux/actions/PaymentAction'
import PaymentGateDc from '../transientForm/PaymentGatwayDc'
import { useForm } from 'react-hook-form'
// import axios from 'axios'
import PaymentModal from '../../components/global/Payment/PaymentModal'
import CommonListModal from '../../global/CommonListModal'
import RateDetailsModal from '../../components/global/RateBand/RateDetailsModal'
import { addEventLog } from '../../redux/actions/EventsLog'
import CONSTANTS from '../../redux/constants'
import { Circles } from 'react-loader-spinner'
import PromoCode from '../../components/global/PromoCode'
import ParkingSchModal from '../../global/ParkingSchModal'
import ConfirmationTerms from '../../global/ConfirmationTerms'
import WalletButtons from '../../components/walletButtons'
import { addScript } from '../../utils/addScript'


function ExtendFormNew(props) {
    const { ticket_id, partner } = useParams()
    const navigate = useNavigate()
    const { register, handleSubmit, formState: { errors }, control, setFocus, reset, setValue, getValues } = useForm()
    const { dispatch, notify, isFetchingPartner, partnerDetails, cards } = props

    const [timeDuration, setTimeDuration] = useState({ days: '0', hours: '0', minutes: '0' })

    // const [newtimeDuration, setNewTimeDuration] = useState({ days: '', hours: '', minutes: '' })


    const [gateData, setGateData] = useState(EMPTY_OBJECT)
    const [walletButtonShow, setWalletButtonShow] = useState(null)
    const [ticketDetails, setTicketDetails] = useState(EMPTY_OBJECT)
    const [loader, setLoader] = useState(false)
    const [rateLoader, setRateLoader] = useState(false)
    const [isDisplayDetails, setIsDisplayDetails] = useState(false)
    const [error, setError] = useState('')
    const [totalLength, setTotalLength] = useState('0.00')
    const [isTokenApiStarts, setIsTokenApiStarts] = useState(false)
    const [isDisplayRateBand, setIsDisplayRateBand] = useState(false)
    const [rateBandData, setRateBandData] = useState(EMPTY_ARRAY)
    const [rateBands, setRateBands] = useState(EMPTY_ARRAY)
    const [termsAndCondition, setTermsAndCondion] = useState(true)
    const [cardToken, setCardToken] = useState('')

    // const [seletedRateBand, setSelectedRateBand] = useState(EMPTY_ARRAY)
    // const [totalHoursLength, setTotalHoursLength] = useState('0.00')

    // confirmation modal 
    const [isConfimationModalOpen, setIsConfimationModalOpen] = useState(false)
    //   
    const [isValidPartner, setIsValidPartner] = useState(true)
    const [partnerdetails, setPartnerDetails] = useState(EMPTY_OBJECT)
    const [isScrollCalendarModal, setIsScrollCalendarModal] = useState(false)
    const [facilityLocData, setFacilityLocData] = useState(null)
    // const facilityLocData = JSON.parse(localStorage.getItem('faclityData'))
    const [isEndingParking, setIsEndingParking] = useState(false)

    // const d2 = moment(new Date().toLocaleString('en-US', { timeZone: facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York' })).format('MM-DD-YYYY hh:mm A')

    const [entryDateTime, setEntryDateTime] = useState(null)
    const [isRateBandSelected, setIsRateBandSelected] = useState(false)
    const [rateBandId, setRateBandId] = useState(null)
    const [selectedRateBand, setSelectedRateBand] = useState(null)
    // const [extendData, setExtendData] = useState(null)
    // const local_checkout_datetime = localStorage.getItem('ExtendData')
    // const extend_data = JSON.parse(local_checkout_datetime)
    const [selctedDateTime, setselctedDateTime] = useState({
        active: false,
        price: null,
        daysHrs: null,
        dateUntill: null,
        bandActive: false,
    })
    const [loginData, setLoginData] = useState(EMPTY_OBJECT)
    const [customeLoaderForRateBand, setCustomeLoaderForRateBand] = useState(false)
    const [currentSelCard, setCurrentCard] = useState(EMPTY_OBJECT)
    // const [currentSelVehicle, setCurrentVehicle] = useState(EMPTY_OBJECT)
    const [cardData, setCardData] = useState(EMPTY_ARRAY)
    const [isCommonModalOpen, setCommonModal] = useState(false)
    const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false)
    const [isSubmittingForm, setIsSubmittingForm] = useState(false)
    const [rateDetailModal, setRateDetailModal] = useState({
        modal: false,
        details: null
    })
    const [ratesChanged, setIsRatesChanged] = useState({
        modal: false,
        loader: false,
        msge: null
    })
    const [rateObj, setRateObj] = useState({
        loader: false,
        data: null
    })
    const [indexForCalc, setIndexForCalc] = useState({
        eventsIndex: null,
        bandIndex: 0,
    })
    const [btnloader, setBtnLoader] = useState({
        extend: false,
        endparking: false
    })
    const [updatedFacilityDate, setUpdatedFacilityDate] = useState(EMPTY_OBJECT)
    const [isIOSDevice, setIsIOSdevice] = useState(false)
    const targetRef = useRef(null)
    // const [onSubmitData, setOnSubmitData] = useState(EMPTY_OBJECT)
    const [paymentReciept, setPaymentReciept] = useState(null)

    const [promoCode, setPromoCode] = useState('')
    const [isRateChangedWithPromo, setIsRateChangedWithPromo] = useState(false)
    const [isPriceZero, setIsPriceZero] = useState(true)

    const [isPromoCodeAppiled, setIsPromoCodeApplied] = useState(false)
    const [durationSelector, setDurationSelector] = useState(1)
    const [dataOnLoad, setDataOnLoad] = useState(EMPTY_OBJECT)
    const loaded = useRef(false)
    const applePaySessionRef = useRef(null)
    const fastTrackRef = useRef(false)

    // FOR PIMS-13904 Inventory Check
    const [warningMessageSchdule, setWarningPark] = useState(false)
    const [avalablityAlert, setAvalablityAlertIsOpen] = useState(false)
    const [availabilityMessage, setAvalablityMessage] = useState('')
    const [warningMessage, setWarningMessage] = useState('')
    const [hoursOfOper, setHoursOfOper] = useState(EMPTY_ARRAY)
    const [midnighNote, setShowMidnightNote] = useState(false)
    const [resetDuration, setResetDuration] = useState(null)
    // FOR PIMS-13904 Inventory Check

    useEffect(() => {
        const facilityLocHost = JSON.parse(localStorage.getItem('faclityData'))
        const localFacilityID = facilityLocHost?.facility?.id ? facilityLocHost?.facility?.id : facilityLocHost?.id ? facilityLocHost?.id : null
        window.scrollTo(0, 0)
        const loginData = loggedInUserData()
        setLoginData(loginData)
        setFacilityLocData(facilityLocHost)
        const d2 = new Date(getConvertedDate(moment(new Date()).tz(facilityLocHost?.facility?.timezone ? facilityLocHost?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')))
        setEntryDateTime(d2)
        if (loginData?.access_token) {
            if (cards?.length != cardData?.length) {
                dispatch(getCardLists()).then((res) => {
                    setCardData(res?.data?.payments)
                    let defaultCard = res?.data?.payments?.filter((item) => {
                        return item.is_default == '1'
                    })
                    reset(formValues => ({ ...formValues, 'card_id': defaultCard?.length > 0 ? defaultCard?.[0]?.payment_profile_id : res?.data?.payments?.[0]?.card_holder_id }))
                    setCurrentCard(defaultCard?.length > 0 ? defaultCard?.[0] : res?.data?.payments?.[0])
                }).catch((err) => {
                    let errObject = {
                        payload: localFacilityID,
                        error: err,
                        errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getCardLists-ExtendFormNew.js-132`))
                    notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                })
            }
        }
    }, [EMPTY_ARRAY, cards])
    useEffect(() => {
        // const local_checkout_datetime = JSON.parse(localStorage.getItem('ExtendData'))
        const paymentrc = JSON.parse(localStorage.getItem('paymentRecipt'))
        // setExtendData(local_checkout_datetime)
        setPaymentReciept(paymentrc)
    }, [EMPTY_ARRAY])

    useEffect(() => {
        if (gateData?.facility) {
            setWalletButtonShow(showhideWalletButton(gateData?.facility))
            if (((gateData?.facility?.facility_configuration?.terms_condition_content && gateData?.facility?.facility_configuration?.terms_condition_content != '') || (partnerDetails?.brand_setting?.terms_condition_content && partnerDetails?.brand_setting?.terms_condition_content != '')) && isPermissionExist(sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions'), 'Display Terms & Conditions Checkbox')) {
                setTermsAndCondion(false)
            }
        }
    }, [gateData])

    const termsChangeHandler = () => {
        setTermsAndCondion(!termsAndCondition)
    }

    // Load Wallet Payment Script
    useEffect(() => {
        // Load Wallet Payment Script
        const paymentGateway = gateData?.facility?.facility_payment_details?.facility_payment_type_id
        // loadScriptUrl(loaded, paymentGateway)
        const applePayScript = getWalletScriptUrl(paymentGateway)
        Object.values(applePayScript)?.map((item) => {
            if (item) {
                addScript(loaded, item, '')
            }
        })
        // Load Wallet Payment Script
    }, [EMPTY_ARRAY, gateData?.facility?.facility_payment_details?.facility_payment_type_id])

    useEffect(() => {
        const deviceType = getDeviceType()
        setIsIOSdevice(deviceType)
    }, [EMPTY_ARRAY])

    useEffect(() => {
        setLoader(true)
        // get partner by slug
        if (partner) {
            // dispatch(getPartnerDetailsBySLug(partner)).then((res) => {
            if (partnerDetails?.email) {
                setPartnerDetails(partnerDetails)
                setIsValidPartner(true)


                localStorage.removeItem('partnerData')
                localStorage.setItem('partnerData', JSON.stringify(partnerDetails))
                const partnerData = partnerDetails
                const color = partnerData?.brand_setting?.color
                const rgb = JSON.parse(partnerData?.brand_setting?.rgb_color)
                if (color) {
                    document.documentElement.style.setProperty('--bs-primary', color)
                    document.documentElement.style.setProperty('base-color', color)
                    document.documentElement.style.setProperty('primary', color)
                    document.documentElement.style.setProperty('textcolor', color)
                    document.documentElement.style.setProperty('--bs-btn-bg', color)
                    document.documentElement.style.setProperty('--bs-primary-rgb', `${rgb?.r},${rgb?.g},${rgb?.b}`)
                    document.documentElement.style.setProperty('--bs-list-group-active-border-color', color)
                    document.documentElement.style.setProperty('--bs-list-group-active-color', color)
                    document.documentElement.style.setProperty('--bs-list-group-active-bg', color)
                    if (ticket_id && ticket_id !== undefined) {
                        priceBreakAPI(true)
                    }
                }

            } else {
                if (partnerDetails) {
                    setIsValidPartner(true)
                } else {
                    setIsValidPartner(false)
                }
                localStorage.removeItem('partnerData')
            }

            // }).catch(() => {

            // })
        }



        // setDaysAmount(EMPTY_OBJECT)

    }, [EMPTY_ARRAY, partnerDetails])

    useEffect(() => {
        if (gateData?.promo_category_id) {
            // FETCH RATE BANDS API DETAILS
            const payload = {
                'ticket_number': ticket_id ? ticket_id : '',
                facility_id: gateData?.facility?.id,
                user_id: loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : '',

            }
            if (gateData?.promo_category_id && gateData?.promo_category_id != '') {
                payload.promo_category_id = gateData?.promo_category_id
            }
            dispatch(fetchRateBands(payload)).then((res) => {
                setCustomeLoaderForRateBand(false)

                if (res?.data) {
                    // SET RATE BANDS DATA
                    setRateBandData(res?.data?.price_band)
                    const rateBandsForSelection = res?.data?.price_band?.map((item) => item?.rate_band_description)
                    const priceForRateBrands = res?.data?.price_band?.map((item) => item?.price)
                    const rateBands = { rateBands: [...rateBandsForSelection], price: [...priceForRateBrands] }
                    setRateBands(rateBands)

                    // priceBreakAPI()


                } else {
                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    let errObject = {
                        payload: payload,
                        error: res,
                        errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} fetchRateBands-ExtendFormNew.js-231`))
                }
            }).catch((err) => {
                let errObject = {
                    payload: payload,
                    error: err,
                    errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                }
                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} fetchRateBands-ExtendFormNew.js-231`))
                notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                setCustomeLoaderForRateBand(false)
                notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
            })
        }
    }, [gateData?.promo_category_id])


    const priceBreakAPI = (rateLoad = false) => {
        setCustomeLoaderForRateBand(true)
        setRateLoader(true)
        dispatch(getRateDetailsData(ticket_id)).then((res) => {
            setRateLoader(false)
            setLoader(false)
            if (res?.data) {

                // Update the value of Fast Track Check Box
                setValue('is_fast_track_enabled', res?.data?.ticket_details?.is_fast_track_enabled)

                setTicketDetails(res.data)
                setUpdatedFacilityDate(res?.data?.facility)
                if (rateLoad) {
                    setDataOnLoad(res?.data)
                }
                const data = JSON.parse(JSON.stringify(res?.data))
                data.total = '0.00'
                data.valid_till = res?.data?.valid_till
                setGateData(data)
                // const d2 = moment(new Date(data.checkout_datetime)).format('MM-DD-YYYY hh:mm A')
                const d2 = new Date(getConvertedDate(moment(new Date(data.checkout_datetime)).format('YYYY-MM-DD HH:mm:ss')))
                setEntryDateTime(d2)
                setTotalLength('0.00')
                localStorage.removeItem('ExtendData')
                localStorage.setItem('ExtendData', JSON.stringify(data))
                if (res?.data?.facility?.is_price_band == '1' && rateLoad) {
                    // SET RATE BAND TRUE
                    setIsDisplayRateBand(true)
                    // FETCH RATE BANDS API DETAILS
                    const payload = {
                        'ticket_number': ticket_id ? ticket_id : '',
                        facility_id: res?.data?.facility?.id,
                        user_id: loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : '',

                    }
                    if (res?.data?.promo_category_id && res?.data?.promo_category_id != '') {
                        payload.promo_category_id = res?.data?.promo_category_id
                    }
                    dispatch(fetchRateBands(payload)).then((res) => {
                        setCustomeLoaderForRateBand(false)

                        if (res?.data) {
                            // SET RATE BANDS DATA
                            setRateBandData(res?.data?.price_band)
                            const rateBandsForSelection = res?.data?.price_band?.map((item) => item?.rate_band_description)
                            const priceForRateBrands = res?.data?.price_band?.map((item) => item?.price)
                            const rateBands = { rateBands: [...rateBandsForSelection], price: [...priceForRateBrands] }
                            setRateBands(rateBands)
                        } else {
                            notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                            let errObject = {
                                payload: payload,
                                error: res,
                                errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                            }
                            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} fetchRateBands-ExtendFormNew.js-231`))
                        }
                    }).catch((err) => {
                        let errObject = {
                            payload: payload,
                            error: err,
                            errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                        }
                        dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} fetchRateBands-ExtendFormNew.js-231`))
                        notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                        setCustomeLoaderForRateBand(false)
                        notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    })
                } else {
                    setCustomeLoaderForRateBand(false)
                }
            } else {
                setCustomeLoaderForRateBand(false)
                setError(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                let errObject = {
                    payload: ticket_id,
                    error: res,
                    errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                }
                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getRateDetailsData-ExtendFormNew.js-206`))
            }
        }).catch((err) => {
            setRateLoader(false)
            let errObject = {
                payload: ticket_id,
                error: err,
                errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
            }
            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getRateDetailsData-ExtendFormNew.js-206`))
            setCustomeLoaderForRateBand(false)
            setError(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
        })
    }


    const handleExtendSubmit = (reservation = false, reservationData, dataPhone) => {
        if (!loader) {
            let extenday = TimeConversion(timeDuration).toFixed(2)

            if ((extenday == '0' || extenday == '0.00') && !rateBandId) {
                // if (isDisplayRateBand) {
                //     notify('error', 'Please select valid duration')
                // } else {
                notify('error', timeValidationConversion(updatedFacilityDate))
                setLoader(false)
                setIsSubmittingForm(false)
                // }
            } else {
                if (!rateBandId) {
                    setTotalLength(extenday)
                }
                setLoader(true)
                let phone = localStorage.getItem('phone')
                let postData = {
                    ticket_number: ticket_id,
                    extendhours: (isDisplayRateBand && rateBandId) ? selectedRateBand?.[0]?.max_stay : totalLength ? TimeConversion(timeDuration).toFixed(2) : extenday,
                    rate_band_id: (isDisplayRateBand && rateBandId) ? rateBandId : isDisplayRateBand ? '' : undefined,
                    email: loginData?.user?.email ? loginData?.user?.email : '',
                    total: gateData?.payable_amount ? gateData?.payable_amount : ''
                }
                // if (reservation) {
                //     postData.phone = dataPhone ? dataPhone : phone

                //     if (loginData?.access_token) {
                //         postData.user_id = loginData?.user?.id
                //         postData.payment_profile_id = currentSelCard?.payment_profile_id ? currentSelCard?.payment_profile_id : ''
                //         postData.card_last_four = currentSelCard?.card_last_four ? currentSelCard?.card_last_four : ''
                //         postData.expiry = currentSelCard?.expiry ? currentSelCard?.expiry : ''
                //         postData.nonce = currentSelCard?.payment_profile_id ? currentSelCard?.payment_profile_id : ''
                //     } else {
                //         if (!isPriceZero) {
                //             postData.nonce = isPriceZero ? '' : postData?.walletPay ? '' : reservationData ? reservationData : ''
                //         }
                //     }
                // }
                if (loginData?.access_token) {
                    postData.phone = dataPhone ? dataPhone : phone ? phone : ticketDetails?.user?.phone_number ? ticketDetails?.user?.phone_number : ''
                    postData.user_id = loginData?.user?.id
                    postData.payment_profile_id = currentSelCard?.payment_profile_id ? currentSelCard?.payment_profile_id : ''
                    postData.card_last_four = currentSelCard?.card_last_four ? currentSelCard?.card_last_four : ''
                    postData.expiry = currentSelCard?.expiry ? currentSelCard?.expiry : ''
                    postData.nonce = currentSelCard?.payment_profile_id ? currentSelCard?.payment_profile_id : ''
                } if (reservation) {
                    postData.phone = dataPhone ? dataPhone : phone
                    if (!isPriceZero) {
                        postData.nonce = isPriceZero ? '' : postData?.walletPay ? '' : reservationData ? reservationData : ''
                    }
                }
                if (reservationData?.paymentMethod && reservationData?.paymentMethod != '') {
                    delete postData.nonce
                    postData.walletPay = reservationData?.walletPay ? reservationData?.walletPay : ''
                    postData.paymentMethods = reservationData?.paymentMethod ? reservationData?.paymentMethod : ''
                    postData.payment_profile_id = ''
                    postData.card_last_four = ''
                    postData.expiry = ''
                }

                // const isFastTrackEnabled = getValues('is_fast_track_enabled')
                postData.is_fast_track_enabled = gateData?.ticket_details?.is_fast_track_enabled == '1' || fastTrackRef.current == 1 ? 1 : 0
                dispatch(postExtendData(postData)).then((res) => {
                    setLoader(false)
                    setIsSubmittingForm(false)
                    if ((res?.status == 200 || res?.status == 201)) {
                        localStorage.removeItem('ExtendData')
                        localStorage.setItem('ExtendData', JSON.stringify(res?.data))
                        navigate(`/${partner}${URL.EXTENDSUCCESS}/${res?.data?.ticket_number}`)
                        closeApplePaySession('success')
                    } else {
                        setLoader(false)
                        notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                        let errObject = {
                            payload: postData,
                            error: res,
                            errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                        }
                        dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} postExtendData-ExtendFormNew.js-309`))
                        closeApplePaySession('failed')
                    }
                }).catch((err) => {
                    let errObject = {
                        payload: postData,
                        error: err,
                        errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                    }
                    setLoader(false)
                    setIsSubmittingForm(false)
                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} postExtendData-ExtendFormNew.js-309`))
                    notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    closeApplePaySession('failed')
                })

            }
        }
    }

    const handleEndParking = () => {
        setIsEndingParking(true)
        setIsConfimationModalOpen(!isConfimationModalOpen)
        dispatch(endParking(gateData?.ticket_number)).then((res) => {
            if (res?.status === 201 || res?.status === 200) {
                if (res?.data && res?.data != null) {
                    notify('success', res?.data?.end_parking_message || errorMessage?.endParkingSuccessMessage)
                    navigateToHomeScreen(partner, navigate, setIsEndingParking)
                } else {
                    notify('success', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    let errObject = {
                        payload: gateData?.ticket_number,
                        error: res,
                        errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} endParking-ExtendFormNew.js-335`))
                    navigateToHomeScreen(partner, navigate, setIsEndingParking)
                }
            } else {
                notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                if (res?.status === 406) {
                    setIsEndingParking(false)
                } else {
                    navigateToHomeScreen(partner, navigate, setIsEndingParking)
                }
                let errObject = {
                    payload: gateData?.ticket_number,
                    error: res,
                    errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                }
                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} endParking-ExtendFormNew.js-335`))
            }
        }).catch((err) => {
            notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
            if (err?.status === 406) {
                setIsEndingParking(false)
            } else {
                navigateToHomeScreen(partner, navigate, setIsEndingParking)
            }
            let errObject = {
                payload: gateData?.ticket_number,
                error: err,
                errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
            }
            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} endParking-ExtendFormNew.js-335`))
        })
    }

    // const handleDaysChange = (e, name) => {
    //     const { value } = e.target
    //     let data = { ...timeDuration }
    //     if (fieldName === 'Days') {
    //         data['days'] = value
    //         setTimeDuration(data)
    //     } else if (fieldName === 'Hours') {
    //         data['hours'] = value
    //         setTimeDuration(data)
    //     } else if (fieldName === 'Minutes') {
    //         data['minutes'] = value
    //         setTimeDuration(data)
    //     }
    // }    

    const deb = useCallback(
        debounce((e, fromDatePicker) => {
            extendTicket(e, fromDatePicker)
        }, 300),
        [gateData])

    const handleTimeLength = (e) => {
        // e?.preventDefault()
        const { value, name, key } = e.target
        let data = { ...timeDuration }
        let rateBandSelected
        if (name == 'day') {
            data['days'] = value
            setTimeDuration({ ...timeDuration, days: Number(value) })
        } else if (name == 'hour') {
            data['hours'] = value
            data['minutes'] = key == 'isStatic' ? 0 : data.minutes
            setTimeDuration({ ...timeDuration, hours: Number(key == 'isStatic' ? 0 : value), minutes: Number(key == 'isStatic' ? 0 : data['minutes']) })
        } else if (name == 'minute') {
            data['minutes'] = value
            data['hours'] = key == 'isStatic' ? 0 : data['hours']
            setTimeDuration({ ...timeDuration, minutes: Number(key == 'isStatic' ? 0 : value), hours: Number(key == 'isStatic' ? 0 : data['hours']) })
        } else if (name == 'minute-up') {
            data['minutes'] = data.minutes + 15 <= 60 ? Number(data.minutes + 15) : 0
            setTimeDuration(prev => ({ ...timeDuration, minutes: prev.minutes + 15 <= 60 ? Number(prev.minutes + 15) : 0 }))
        } else if (name == 'minute-down') {
            data['minutes'] = data.minutes - 15 >= 0 ? Number(data.minutes - 15) : 60
            setTimeDuration(prev => ({ ...timeDuration, minutes: prev.minutes - 15 >= 0 ? Number(prev.minutes - 15) : 60 }))
        } else if (name == 'hour-up') {
            data['hours'] = data.hours + 1 <= 24 ? Number(data.hours + 1) : 0
            setTimeDuration(prev => ({ ...timeDuration, hours: prev.hours + 1 <= 24 ? Number(prev.hours + 1) : 0 }))
        } else if (name == 'hour-down') {
            data['hours'] = data.hours - 1 >= 0 ? Number(data.hours - 1) : 24
            setTimeDuration(prev => ({ ...timeDuration, hours: prev.hours - 1 >= 0 ? prev.hours - 1 : 24 }))
        } else if (name == 'day-up') {
            data['days'] = data.days + 1 <= 31 ? Number(data.days + 1) : 0
            setTimeDuration(prev => ({ ...timeDuration, days: prev.days + 1 <= 31 ? Number(prev.days + 1) : 0 }))
        } else if (name == 'day-down') {
            data['days'] = data.days - 1 >= 0 ? Number(data.days - 1) : 31
            setTimeDuration(prev => ({ ...timeDuration, days: prev.days - 1 >= 0 ? Number(prev.days - 1) : 31 }))
        } else if ((name && name?.[0]) === 'rateBands') {
            const { value } = e.target
            rateBandSelected = rateBandData?.filter((item) => item?.rate_band_description == value[0])
            setSelectedRateBand(rateBandSelected)
            setRateBandId(rateBandSelected[0].id)
            // for the rate hour 
            const rateBandHour = getHoursForRateBand(rateBandSelected)
            // setSelectedRateBand(rateBandSelected)
            // to set hours duration
            data['hours'] = Number(rateBandHour)
            let totalHours = '0.00'

            if (rateBandSelected?.[0]?.max_stay) {
                const max_stay_time = rateBandSelected?.[0]?.max_stay?.split('.')
                const minutes = (Number(max_stay_time[1]) / 60)
                totalHours = Number(max_stay_time[0]) + Number(minutes)
            }

            if (totalHours == '0.00') {
                setTotalLength('0')
            }
            // else if(value.length > 0 && value[0].toLowerCase()?.includes('checkoutWithTime')) {
            //     // setTotalHoursLength('0')
            // } else {
            //     setTotalLength(totalHours)
            // }

            setTimeDuration(data)
            // reset(formValues => ({ ...formValues, 'rate_band_id': seletedRateBand?.[0]?.id }))
            // // FETCH FACILITYRATE
            // const payload = {
            //     promocode: '',
            //     user_id: loggedInUserData()?.user?.id ? loggedInUserData()?.user?.id : '',
            //     rate_band_id: seletedRateBand?.[0]?.id,
            //     //facility_id: faciltyData?.facility?.id,
            //     // length_of_stay: totalHoursLength,
            //     // 'encrypt': facility,
            // }
            // if (payload?.length !== 0) {
            //     deb(payload, false)
            // }
        }
        // if (name === 'Days') {
        //     data['days'] = value
        //     setTimeDuration(data)
        // } else if (name === 'Hours') {
        //     data['hours'] = value
        //     setTimeDuration(data)
        // } else if (name === 'Minutes') {
        //     data['minutes'] = value
        //     setTimeDuration(data)
        // }
        let extenday = TimeConversion(data).toFixed(2)
        if (!isDisplayRateBand) {


            setTotalLength(extenday)
        }


        if (ticket_id && ticket_id !== undefined) {
            let postData

            if (isDisplayRateBand) {
                postData = {
                    'rate_band_id': rateBandSelected?.[0]?.id ? rateBandSelected?.[0]?.id : '',
                    'band_rate': parseFloat(rateBandSelected?.[0]?.price ? rateBandSelected?.[0]?.price : 0),
                    'length': rateBandSelected?.[0]?.id ? rateBandSelected?.[0]?.max_stay : extenday,
                    // 'length': '',
                    'ticket_number': ticket_id
                }
                // if(value.length > 0 && value[0].toLowerCase()?.includes('checkoutWithTime')) {
                postData.checkoutWithTime = true
                // }
            } else {
                postData = {
                    'length': extenday,
                    'ticket_number': ticket_id
                }
            }
            setIsTokenApiStarts(true)

            // HERE
            deb(postData)
        }


    }

    const extendTicket = (postData, fromDatePicker = false) => {
        let checkoutWithTime = false
        if (postData.checkoutWithTime) {
            checkoutWithTime = true
            delete postData.checkoutWithTime
        }
        let payload = { ...postData, email: loginData?.user?.email ? loginData?.user?.email : '' }
        setRateLoader(true)
        setLoader(true)
        dispatch(getRateHourData(payload)).then((res) => {
            setCustomeLoaderForRateBand(false)
            if (res?.data) {
                // Check availability
                if ((res?.data?.availability != null && res?.data?.availability_msg != null && Number(res?.data?.availability) === 0 && res?.data?.availability_msg !== '')) {
                    handleGarageInventory(res?.data)
                } else {
                    if (res?.data?.card && res?.data?.card != '') {
                        setIsPriceZero(true)
                    } else {
                        if (Number(res?.data?.payable_amount) > 0) {
                            setIsPriceZero(false)
                        } else {
                            setIsPriceZero(true)
                        }
                    }
                    setLoader(false)
                    if (fromDatePicker) {
                        setselctedDateTime({ ...selctedDateTime, bandActive: true, active: true, price: res.data?.parking_amount, dateUntill: res.data?.checkout_time, daysHrs: getHoursIndate(postData.length) })
                    }
                    setRateLoader(false)
                    setIsTokenApiStarts(false)
                    const data = {
                        ...gateData,
                        ...res?.data,
                        // paid_amount: '0.00'
                    } // need to hide validated amount until extend not done because we don't use this at extend PIMS-11903 point8(e)
                    // data.total = res?.data?.rate
                    // data.valid_till = res?.data?.valid_till
                    // data.discount_amount = 0
                    setGateData(data)
                    // const d2 = moment(new Date(data.checkout_datetime)).format('YYYY-MM-DD hh:mm A')
                    // setEntryDateTime(d2)
                    if (checkoutWithTime) {
                        const currentTime = new Date(getConvertedDate(moment(res?.data?.current_time).format('YYYY-MM-DD HH:mm:ss')))
                        const checkoutTime = new Date(getConvertedDate(moment(res?.data?.checkout_time).format('YYYY-MM-DD HH:mm:ss')))
                        const totalHours = moment(checkoutTime).diff(currentTime, 'minutes')
                        const timeRemain = TimeConversionInHours(totalHours)
                        setTotalLength(timeRemain)
                    }
                }

            } else {
                setselctedDateTime({ ...selctedDateTime, bandActive: false })
                setIndexForCalc({
                    ...indexForCalc,
                    eventsIndex: null,
                    bandIndex: 0,
                })
                if (res?.status == 422 || res?.status == 406) {
                    setIsRatesChanged({
                        loader: false,
                        modal: true,
                        msge: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                    })
                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                } else if (res?.status == 502) {
                    setCustomeLoaderForRateBand(false)
                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                } else {
                    setLoader(false)
                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    setIsTokenApiStarts(false)
                    setRateLoader(false)
                    setTotalLength('0')
                    setIsRateBandSelected(false)
                    setRateBandId(null)
                    setTimeDuration({ days: '0', hours: '0', minutes: '0' })
                }
            }

        }).catch((err) => {
            setselctedDateTime({ ...selctedDateTime, bandActive: false })
            setIndexForCalc({
                ...indexForCalc,
                eventsIndex: null,
                bandIndex: 0,
            })
            if (err?.status == 422 || err?.status == 406) {
                setIsRatesChanged({
                    loader: false,
                    modal: true,
                    msge: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                })
                notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
            } else if (err?.status == 502) {
                setCustomeLoaderForRateBand(false)
                notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
            } else {
                let errObject = {
                    payload: payload,
                    error: err,
                    errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                }
                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getRateHourData-ExtendFormNew.js-524`))
                setCustomeLoaderForRateBand(false)
                setLoader(false)
                notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                setIsTokenApiStarts(false)
                setRateLoader(false)
                setTotalLength('0')
                setIsRateBandSelected(false)
                setRateBandId(null)
                setTimeDuration({ days: '0', hours: '0', minutes: '0' })
            }
        })
    }


    // modal confirmation

    const handleConfimationModal = () => {
        setIsConfimationModalOpen(!isConfimationModalOpen)
    }

    const openDateCalendar = () => {
        if (selctedDateTime.active) {
            setselctedDateTime({
                ...selctedDateTime,
                active: false,
                bandActive: false
                // price: null,
                // daysHrs: null,
                // dateUntill: null,
            })
            priceBreakAPI(false)
            setTotalLength('0')
            setIsRateBandSelected(false)
            // setIsDisplayRateBand(false)
            setRateBandId(null)
            setTimeDuration({ days: '0', hours: '0', minutes: '0' })
        } else {
            setIsScrollCalendarModal(true)
        }
    }

    const handleEntryTime = (event) => {
        setIsRateBandSelected(false)
        localStorage.removeItem('seletedRateBand')
        // setEntryDateTime(event)
        // setValue('entry_time',event)       
        // let currentTime = exitDateTime
        // const currentTime = moment(new Date(local_checkout_datetime?.checkout_datetime ? local_checkout_datetime.checkout_datetime : gateData.checkout_datetime)).format('MM-DD-YYYY hh:mm A')
        // const currentTime = moment(new Date(getConvertedDate(moment(new Date(local_checkout_datetime?.checkout_datetime ? local_checkout_datetime.checkout_datetime : gateData.checkout_datetime)).format('YYYY-MM-DD HH:mm:ss')))).format('YYYY-MM-DD HH:mm:ss')
        const localDT = gateData?.checkout_datetime ? gateData?.checkout_datetime : gateData?.checkout_datetime
        const inputDate = moment.tz(localDT, facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York')
        const newYorkDate = inputDate.clone().tz(facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York')
        const currentTime = new Date(getConvertedDate(moment(newYorkDate).tz(facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')))

        let pickTime = event
        let hours = diff_hours(pickTime, currentTime)
        setTotalLength(hours)
        let daysUpd = Math.floor(hours / 24)
        let hoursUpd = Number(hours % 24).toFixed(2).split('.')[0]
        let minutesUpd = Number(hours % 24).toFixed(2).split('.')[1]
        setTimeDuration({ ...timeDuration, days: Number(daysUpd), hours: Number(hoursUpd), minutes: Number(minutesUpd) })
        // const payload = { 'encrypt': facility, length: hours }
        const postData = {
            'length': hours,
            'ticket_number': ticket_id,
            'rate_band_id': isDisplayRateBand ? '' : undefined
        }
        if (postData?.length !== 0) {
            deb(postData, true)
        }
    }

    const diff_hours = (endTime, startTime) => {
        // const startDate = new Date(startTime)
        // const endDate = new Date(endTime)
        // let timeDiff
        // if (!isNaN(startDate) && !isNaN(endDate)) {
        //     const timeDifferenceInMilliseconds = endDate - startDate
        //     const hours = Math.floor(timeDifferenceInMilliseconds / 3600000)
        //     const minutes = Math.floor(
        //         (timeDifferenceInMilliseconds % 3600000) / 60000
        //     )
        //     timeDiff = `${hours}.${minutes < 10 ? '0' + minutes : minutes}`
        // } else {
        //     timeDiff = 'Invalid Time'
        // }
        let start = new Date(getConvertedDate(moment(startTime)?.format('YYYY-MM-DD HH:mm'))).getTime()
        let end = new Date(getConvertedDate(moment(endTime)?.format('YYYY-MM-DD HH:mm'))).getTime()
        var diff = moment(end).diff(start, 'minutes')
        let timeDiff
        if (!isNaN(start) && !isNaN(end)) {
            var hours = Math.floor(diff / 60)
            var minutes = Math.floor(diff % 60)
            timeDiff = `${hours}.${minutes < 10 ? '0' + minutes : minutes}`
        } else {
            timeDiff = 'Invalid Time'
        }
        return timeDiff
    }
    const getHoursIndate = (hours) => {
        let dt = getHoursIndayFormat(hours, false)
        return `${Number(dt?.day) > 1 ? dt.day + ' Days ' : Number(dt?.day) == 1 ? dt.day + ' Day ' : ''}
            ${Number(dt?.hour) > 1 ? dt.hour + ' Hours' : Number(dt?.hour) == 1 ? dt.hour + ' Hour' : ''}
            ${Number(dt?.minute) > 1 ? dt.minute + ' Minutes' : Number(dt?.minute) == 1 ? dt.minute + ' Minute' : ''}`
        // if (Number(hours) > 0) {
        //     const day = Math.floor(Number(hours) / 24)
        //     if (Number(hours) % 24 === 0) {
        //         return `${day} ${day === 1 ? 'Day' : 'days'}`
        //     }
        //     return (Number(hours) < 1) ? convertTimeToDoubleDig(hours) + ' MM' : (Number(hours) === 1) ? convertTimeToDoubleDig(hours) + ' HR' : convertTimeToDoubleDig(hours) + ' HRS'
        // }
    }
    const getDateFormatToshow = (dt) => {
        return moment(dt).format('MMM DD, YYYY hh:mm A')
    }

    const handleValidateTicket = (paymentData) => {
        if (paymentData?.paid_date) {
            notify('error', 'This ticket is already validated.')
        } else {
            navigate(`/${partner}${URL?.SCAN_VALIDATE}`, { state: { redirectUrl: `/${partner}${URL?.EXTEND_URL}/${ticket_id}` } })
        }
    }

    const handleCommonListModal = () => {
        if (cardData?.length > 0) {
            setCommonModal(!isCommonModalOpen)
        } else {
            handlePaymentModal()
        }
    }

    const handlePaymentModal = () => { setIsPaymentModalOpen(!isPaymentModalOpen) }
    const closeApplePaySession = (endsession) => {
        if (applePaySessionRef.current) {
            if (endsession === 'success') {
                applePaySessionRef.current.completePayment(window.ApplePaySession.STATUS_SUCCESS)
            } else if (endsession === 'failed') {
                applePaySessionRef.current.completePayment(window.ApplePaySession.STATUS_FAILURE)
            } else {
                applePaySessionRef.current.abort()
            }
        }
    }

    const onSubmit = (data) => {
        if (!loader) {
            let extenday = TimeConversion(timeDuration).toFixed(2)
            if ((extenday == '0' || extenday == '0.00') && !isDisplayRateBand) {
                // if (isDisplayRateBand) {
                //     notify('error', 'Please select valid duration')
                // } else {
                notify('error', errorMessage?.validDuration)
                // }
            } else {
                setIsSubmittingForm(true)
                if (!isSubmittingForm) {
                    // setOnSubmitData(data)
                    handleSubmitAction(data)
                }
            }
        }
    }

    const handleSubmitAction = (data) => {
        if (loginData?.access_token) {
            if (currentSelCard?.payment_profile_id || data?.walletPay || (ticketDetails?.ticket_details?.is_fast_track_enabled == '1' && ticketDetails?.fastTrackData && Object.keys(ticketDetails?.fastTrackData).length > 0)) {
                handleExtendSubmit(true, data?.walletPay ? data : null, data?.phone ? data?.phone : ticketDetails?.user?.phone_number ? ticketDetails?.user?.phone_number : '')
            } else {
                notify('error', errorMessage?.selectPaymewntMethod)
            }
        } else {
            // const payload = {
            //     'Account': data?.card_number ? data?.card_number : '',
            //     'ExpirationMonth': data?.expiry ? data?.expiry.substr(0, 2) : '',
            //     'ExpirationYear': data?.expiry ? `20${data?.expiry.substr(2, 5)}` : '',
            //     'CVV': data?.cvv ? data?.cvv : ''
            // }
            // const headers = { 'Authorization': facilityLocData?.DATACAP_TOKEN, 'Content-Type': 'application/json', Accept: 'application/json' }
            // axios.post(facilityLocData?.DATACAP_OTU_URL, payload, { headers })
            // .then((response) => {
            //     if (response?.data) {
            //         handleExtendSubmit(true, response?.data, data.phone)
            //     } else if (response?.Error) {
            //         setIsSubmittingForm(false)
            //         notify('error', response?.data ? response?.data?.Errors?.[0] : errorMessage?.somethingWentWrong)
            //     }
            // }).catch((err) => {
            //     setIsSubmittingForm(false)
            //     notify('error', err?.response?.data ? err?.response?.data?.Errors?.[0] : errorMessage?.somethingWentWrong)
            // })
            if (gateData?.facility?.facility_payment_details?.facility_payment_type_id == '3' && cardToken && cardToken.token) {
                // For Fiserv, use cardToken to create payment data
                const card = {
                    name_on_card: data?.name_on_card,
                    card_number: cardToken.token,
                    expiration_date: formatExpiryDate(cardToken.expiry),
                    security_code: '',
                    zip_code: data?.zip_code
                }
                const nonce = encryptionHandler(card)
                handleExtendSubmit(true, data?.walletPay ? data : nonce, data?.phone ? data?.phone : ticketDetails?.user?.phone_number ? ticketDetails?.user?.phone_number : '')
            } else {
                const card = {
                    name_on_card: data?.name_on_card,
                    card_number: data?.card_number,
                    expiration_date: data?.expiry,
                    security_code: data?.cvv,
                    zip_code: data?.zip_code
                }
                const nonce = encryptionHandler(card)
                handleExtendSubmit(true, data?.walletPay ? data : nonce, data.phone ? data.phone : ticketDetails?.user?.phone_number ? ticketDetails?.user?.phone_number : '')
            }
        }
    }


    const returnClockTimer = () => {
        return (
            <ClockTimer
                screen={'extend'}
                facilityData={gateData}
                isExpire
            />
        )
    }

    const retunnValidateTicket = () => {
        if (isPromoValidateButton(gateData, ['2', '3'], ticketDetails) && checkEstimateTime(gateData, ticketDetails) && gateData?.facility?.facility_configuration?.is_display_validate_button == 1 && (!gateData?.reservation_id || !gateData?.reservation_id === null) && (!gateData?.paid_date) && ticketDetails?.is_checkout != '1') {
            return (
                <div className='col-sm-12 mb-3'>
                    <button
                        type="button"
                        className='text-decoration-none border-btn border bg-white text-primary border-primary rounded text-center w-100 ps-4 pe-4 pt-2 pb-2'
                        onClick={() => handleValidateTicket(gateData)}
                        disabled={loader}
                        style={{ opacity: (loader) ? '0.7' : '1' }}
                    >
                        Validate Ticket
                    </button>
                </div>
            )
        } else {
            return ''
        }

    }

    const handleCurrentSelection = (item) => {
        setCurrentCard(item)
    }

    const handleRateDetail = () => {
        if (!rateObj.loader) {
            setRateObj({
                ...rateObj,
                loader: true
            })
            dispatch(fetchRateDetailData(gateData?.facility?.id)).then((res) => {
                if (res.data) {
                    setRateObj({
                        ...rateObj,
                        data: res?.data,
                        loader: false
                    })
                    setRateDetailModal({ ...rateDetailModal, modal: true })
                } else {
                    notify('error', 'Details not found.')
                    setRateObj({
                        ...rateObj,
                        loader: false
                    })
                }
            })
        }

    }

    const handleScroll = () => {
        if (targetRef.current) {
            targetRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    }

    const refreshPage = () => {
        setIsRatesChanged({ ...ratesChanged, loader: true })
        window.location.reload()
    }

    const handleGarageInventory = (markerPayload) => {
        // dispatch(checkInventoryDetails(markerPayload)).then((res) => {
        // setIsSubmittingForm(false)

        if (Number(markerPayload?.warning_on_reservation) === 1 && markerPayload?.facility_hours_of_operation?.length > 0) {
            setWarningPark(!warningMessageSchdule)
            setWarningMessage(markerPayload?.warning_on_reservation_msg)
            setHoursOfOper(markerPayload?.facility_hours_of_operation)
            const selData = markerPayload?.facility_hours_of_operation?.filter((item) => item?.formatted_close_time == '12:00 am (midnight next day)')
            setShowMidnightNote(selData.length > 0 ? true : false)
            setIsSubmittingForm(false)
            setAvalablityAlertIsOpen(false)
        } else if ((Number(markerPayload?.availability) === 0 && markerPayload?.availability_msg !== '')) {
            setAvalablityAlertIsOpen(true)
            // setAvalablityAlertIsOpen(!avalablityAlert)
            setAvalablityMessage(markerPayload?.availability_msg)
            setIsSubmittingForm(false)
        } else if (markerPayload?.Error) {
            setAvalablityAlertIsOpen(false)
            setIsSubmittingForm(false)
            notify('error', markerPayload ? markerPayload?.Errors?.[0] : errorMessage?.somethingWentWrong)
            let errObject = {
                payload: markerPayload,
                error: markerPayload,
                errorMessage: markerPayload?.errors?.message ? markerPayload?.errors?.message : errorMessage?.somethingWentWrong
            }
            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} faciltyOnMarker-TransientForm.js-955`))
        } else {
            //    Do Nothing
        }
        // }).catch((err) => {
        //     setIsSubmittingForm(false)
        //     notify('error', err?.response?.data ? err?.response?.data?.Errors?.[0] : errorMessage?.somethingWentWrong)
        //     let errObject = {
        //         payload: markerPayload,
        //         error: err,
        //         errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
        //     }
        //     dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} faciltyOnMarker-TransientForm.js-955`))
        // })
    }

    const resetFormRates = () => {
        let localFacData = gateData
        localFacData.payable_amount = 0
        localFacData.is_price_applicable = '0'
        localFacData.parking_amount = 0
        localFacData.processing_fee = 0
        localFacData.tax_rate = 0
        localFacData.tax_fee = 0
        localFacData.base_amount = 0
        localFacData.discount_amount = 0
        localFacData.discount_hours = 0
        localFacData.main_ticket = null
        localFacData.new_price = 0
        setTimeDuration({ days: '0', hours: '0', minutes: '0' })
        setTotalLength('0.00')

        if (gateData?.facility?.facility_configuration?.is_overnight_hourly_enabled == '1') {
            localFacData.surcharge_fee = 0
        }
        setGateData(localFacData)
        setAvalablityAlertIsOpen(false)
        setWarningPark(false)
        setResetDuration(resetDuration + 1)
        setselctedDateTime({
            active: false,
            price: null,
            daysHrs: null,
            dateUntill: null,
            bandActive: false
        })
    }

    const handleChange = (event) => {
        const { name, checked } = event.target
        const updatedgateData = { ...gateData }
        if (name == 'is_fast_track_enabled') {
            updatedgateData[name] = !checked
            setGateData((prev) => ({
                ...prev,
                [name]: !checked
            }))
            fastTrackRef.current = !fastTrackRef.current
            setValue('is_fast_track_enabled', !fastTrackRef.current)
        }
    }

    return (
        isFetchingPartner ? null : isEndingParking ? <div className='main d-flex align-items-center justify-content-center'><Loader /></div> : <div className={'Pave main'}>
            <MiniHeader isDisplayBack={true} title={'EXTEND STAY'} partnerdetails={partnerdetails} />
            {error ? <NoData message={error} /> :
                (isValidPartner) ?
                    (loader && gateData == EMPTY_OBJECT) ?
                        <div className='d-flex align-items-center justify-content-center'><Loader /></div> :
                        gateData != EMPTY_OBJECT ? (
                            <>
                                <UpperHeader faciltyData={gateData} totalHoursLength={totalLength?.toString()} isDirection screen='Extend New' reservationData={gateData} partnerDetails={partnerDetails} />

                                <Container className='border-bottom'>
                                    <Row className='m-0 p-0'>
                                        <Form onSubmit={(e) => e.preventDefault()}>
                                            <Row>
                                                <Col className='pt-3 pb-3'>
                                                    <Form.Group className="mb-3" controlId="formBasicPassword">
                                                        {/* Hiding the PromoCode Field on Extend Form as Discussed with Trapti Mam, 
                                                            Since the conditions are not handelled at BE Yet. - Hemant*/}
                                                        <span className='d-none'>
                                                            {/* PromoCode ---- */}
                                                            {/* {partner !== 'intrapark' && */}
                                                            {((isPromoValidateButton(gateData, ['1', '3']) && !gateData?.event_id) && (!gateData?.permit_request_id || gateData?.permit_request_id == '')) &&
                                                                <PromoCode
                                                                    length={totalLength?.toString()}
                                                                    setFaciltyData={setUpdatedFacilityDate}
                                                                    setValue={setValue}
                                                                    getValues={getValues}
                                                                    setPromoCode={setPromoCode}
                                                                    promoCode={promoCode}
                                                                    notify={notify}
                                                                    screen='extendForm'
                                                                    ticketDetails={gateData}
                                                                    // setIsPriceZero={setIsPriceZero}
                                                                    discountAvailed='9'
                                                                    setPaymentData={setGateData}
                                                                    isTicketApply
                                                                    // checkPromoWithLicense={gateData?.promocode_discount?.promocode?.promocode}
                                                                    // checkPromo={checkPromo}
                                                                    // event_id={selectedEv}
                                                                    setIsSubmittingForm={setIsSubmittingForm}
                                                                    isRateChangedWithPromo={isRateChangedWithPromo}
                                                                    setIsRateChangedWithPromo={setIsRateChangedWithPromo}
                                                                    setCustomeLoaderForRateBand={setCustomeLoaderForRateBand}
                                                                    isPromoCodeAppiled={isPromoCodeAppiled}
                                                                    setIsPromoCodeApplied={setIsPromoCodeApplied}
                                                                    selectedPastDate={null}

                                                                // NOTE:- faciltyData?.paid_type === '9' means ticket is not validated except from this restrict promocode:- condition from @Vikrant
                                                                />
                                                            }
                                                        </span>
                                                        <Row>
                                                            {isPermissionExist(sortPortalPermissionByKey(partnerdetails, 'Restricted Permissions'), 'Enable Fast-Track Checkin') && (gateData?.facility?.facility_configuration?.enable_fast_track == '1') && (Number(gateData?.payable_amount > 0) || gateData?.ticket_details?.is_fast_track_enabled == 1) ?
                                                                <Form.Group className="d-flex p-0 m-0">
                                                                    <input
                                                                        type="checkbox"
                                                                        id='is_fast_track_enabled'
                                                                        name='is_fast_track_enabled'
                                                                        defaultChecked={gateData?.ticket_details?.is_fast_track_enabled}
                                                                        // {...register('is_fast_track_enabled', {
                                                                        //     checked: (gateData?.ticket_details?.is_fast_track_enabled == 1) ? true : false,
                                                                        //     onChange: (e) => handleChange(e)
                                                                        // }
                                                                        // )}
                                                                        checked={(gateData?.ticket_details?.is_fast_track_enabled == 1 || fastTrackRef.current) ? true : false}
                                                                        onChange={(e) => {
                                                                            handleChange(e)
                                                                        }}
                                                                        disabled={(gateData?.ticket_details?.is_fast_track_enabled == 1 || isSubmittingForm)}
                                                                        className='me-2'
                                                                        style={{ 'width': 'auto' }}
                                                                    />
                                                                    <Form.Label className='d-flex align-items-center text-primary fw-bold mb-0 styleLables'>Fast Track</Form.Label>
                                                                </Form.Group>
                                                                : null}

                                                            {isDisplayRateBand ? <div>
                                                                <>
                                                                    {!selctedDateTime?.bandActive ? <Form.Label className='text-primary mb-0 pb-0 styleLables'>Rate Band <span className='text-danger'>*</span></Form.Label> : gateData?.facility?.facility_configuration?.is_overnight_hourly_enabled == '1' ? <Form.Label className='text-primary mb-0 pb-0 styleLables p-0 m-0'>{gateData?.event_id ? 'Event Rates' : 'Stay Duration'} <span className='text-danger'>*</span></Form.Label> : ''}
                                                                    <ReactMobiltySpinner
                                                                        handleTimeLength={(e) => handleTimeLength(e)}
                                                                        // currRateBand={timeDuration?.minutes}
                                                                        isRateBand
                                                                        isRateBandSelected={isRateBandSelected}
                                                                        rateBands={rateBands}
                                                                        setIsRateBandSelected={setIsRateBandSelected}
                                                                        setselctedDateTime={setselctedDateTime}
                                                                        selctedDateTime={selctedDateTime}
                                                                        rateBandData={rateBandData}
                                                                        setIndexForCalc={setIndexForCalc}
                                                                        indexForCalc={indexForCalc}
                                                                        setTotalHoursLength={setTotalLength}
                                                                        setSeletedRateBand={setSelectedRateBand}
                                                                        facilityData={updatedFacilityDate}
                                                                        setFacilityData={setUpdatedFacilityDate}
                                                                        isMultiParking={gateData?.facility?.is_multiday_parking != 0}
                                                                        page='extend'
                                                                        priceBreakAPI={priceBreakAPI}
                                                                        setTimeDuration={setTimeDuration}
                                                                        setRateBandId={setRateBandId}
                                                                        partnerdetails={partnerdetails}
                                                                        setCustomeLoaderForRateBand={setCustomeLoaderForRateBand}
                                                                        customeLoaderForRateBand={customeLoaderForRateBand}
                                                                        setIsPriceZero={() => { }}
                                                                        isRateChangedWithPromo={isRateChangedWithPromo}
                                                                        setIsRateChangedWithPromo={setIsRateChangedWithPromo}
                                                                        setResetPromo={() => { }}
                                                                        durationSelector={durationSelector}
                                                                        setDurationSelector={setDurationSelector}
                                                                        handleBlur={() => { }}
                                                                        hotel_type={updatedFacilityDate?.facility_configuration?.is_facility_hotel_type}
                                                                        openDateCalendar={openDateCalendar}
                                                                        currentSelVehicle={EMPTY_OBJECT}
                                                                        totalHoursLength={totalLength}
                                                                        // for the event and rate
                                                                        setIsRateOrEventShow={() => { }}
                                                                        is_rate_or_event_show={0}
                                                                        resetBand={0}
                                                                        curRateBandRef={null}
                                                                        oversizeLoader={false}
                                                                        updatedListRef={null}
                                                                        disableRates={false}
                                                                        ticketDetails={gateData}
                                                                        dataOnLoad={dataOnLoad}
                                                                        setVerifyDetails={() => { }}
                                                                        startDatePopup={<></>}
                                                                    />
                                                                    {(partner !== 'parkingpayments' && rateBands?.rateBands?.length > 0) && <>
                                                                        <div className={`${updatedFacilityDate?.is_custom_picker_enabled == '1' ? '' : 'mb-2 '}text-end d-flex align-items-center justify-content-end`}>
                                                                            {rateObj.loader && <><div><Loader color='grey' hideMargin size='16' /></div><span>&nbsp;</span></>}
                                                                            {updatedFacilityDate?.facility_configuration?.show_rate_detail == '1' ? <span className={`p-0 btn btn-link btn-sm mt-0${rateObj.loader ? ' disabled' : ''}`} onClick={handleRateDetail}>Rate Detail</span> : ''}
                                                                        </div>
                                                                        <RateDetailsModal rateDetailModal={rateDetailModal} setRateDetailModal={setRateDetailModal} rateObj={rateObj} />
                                                                    </>}
                                                                </>
                                                                {updatedFacilityDate?.is_custom_picker_enabled == '1' && <div className='p-0 m-0 d-flex justify-content-center align-items-center row'>
                                                                    <div className={`${selctedDateTime?.bandActive ? '' : isRateBandSelected ? 'd-none' : ''} border border-2 rounded m-2 pb-2 pt-2`} onClick={openDateCalendar} style={
                                                                        (partnerdetails?.brand_setting?.color && selctedDateTime?.bandActive) ? { backgroundColor: partnerdetails?.brand_setting?.color, color: '#fff' } : {}
                                                                    }>
                                                                        <div className='pb-1 pt-1 d-flex justify-content-between align-items-center'>
                                                                            <div className='lh-sm'>{(selctedDateTime?.active && !isRateBandSelected) ? selctedDateTime?.daysHrs : 'Custom Date & Time'}<div className={`${selctedDateTime?.bandActive ? '' : 'text-muted'} sub-label small`}><small>{(selctedDateTime?.active && !isRateBandSelected) ? 'Until ' + getDateFormatToshow(selctedDateTime?.dateUntill) : 'Select Date & Time'}</small></div></div>
                                                                            <span>{(selctedDateTime?.active && !isRateBandSelected) ? '$' + Number(selctedDateTime?.price).toFixed(2) : '--'}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>}
                                                                {/* <div className='mt-3 mb-3'>
                                                                        <Form.Label className='text-primary  styleLables'>Pick Date & Time</Form.Label>
                                                                        <button className='form-control text-left' onClick={openDateCalendar}>{entryDateTime}</button>
                                                                    </div> */}
                                                            </div> : <>
                                                                {gateData?.facility?.facility_configuration?.is_overnight_hourly_enabled == '1' ? <Form.Label className='text-primary mb-0 pb-0 styleLables'>{gateData?.event_id ? 'Event Rates' : 'Stay Duration'} <span className='text-danger'>*</span></Form.Label> : ''}
                                                                <ReactMobiltySpinner
                                                                    handleTimeLength={(e) => handleTimeLength(e)}
                                                                    currDays={timeDuration?.days ? Number(timeDuration?.days) : 0}
                                                                    currHour={timeDuration?.hours ? Number(timeDuration?.hours) : 0}
                                                                    currMin={timeDuration?.minutes ? Number(timeDuration?.minutes) : 0}
                                                                    isMultiParking={gateData?.facility?.is_multiday_parking != 0}
                                                                    setIsRateBandSelected={setIsRateBandSelected}
                                                                    setselctedDateTime={setselctedDateTime}
                                                                    selctedDateTime={selctedDateTime}
                                                                    rateBandData={rateBandData}
                                                                    setIndexForCalc={setIndexForCalc}
                                                                    indexForCalc={indexForCalc}
                                                                    setTotalHoursLength={setTotalLength}
                                                                    setSeletedRateBand={setSelectedRateBand}
                                                                    facilityData={updatedFacilityDate}
                                                                    setFacilityData={setUpdatedFacilityDate}
                                                                    page='extend'
                                                                    priceBreakAPI={priceBreakAPI}
                                                                    setTimeDuration={setTimeDuration}
                                                                    setRateBandId={setRateBandId}
                                                                    partnerdetails={partnerdetails}
                                                                    setCustomeLoaderForRateBand={setCustomeLoaderForRateBand}
                                                                    customeLoaderForRateBand={customeLoaderForRateBand}
                                                                    setIsPriceZero={() => { }}
                                                                    isRateBandSelected={isRateBandSelected}
                                                                    setResetPromo={() => { }}
                                                                    durationSelector={durationSelector}
                                                                    setDurationSelector={setDurationSelector}
                                                                    handleBlur={() => { }}
                                                                    hotel_type={updatedFacilityDate?.facility_configuration?.is_facility_hotel_type}
                                                                    openDateCalendar={openDateCalendar}
                                                                    currentSelVehicle={EMPTY_OBJECT}
                                                                    isRateBand={updatedFacilityDate?.is_price_band == '1'}
                                                                    totalHoursLength={totalLength}
                                                                    setIsRateOrEventShow={() => { }}
                                                                    is_rate_or_event_show={0}
                                                                    resetBand={0}
                                                                    curRateBandRef={null}
                                                                    oversizeLoader={false}
                                                                    updatedListRef={null}
                                                                    disableRates={false}
                                                                    ticketDetails={gateData}
                                                                    dataOnLoad={dataOnLoad}
                                                                    setVerifyDetails={() => { }}
                                                                    startDatePopup={<></>}
                                                                />
                                                            </>}
                                                        </Row>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Row>
                                </Container>

                                <QRCodeComp
                                    paymentData={gateData}
                                    screen='extend'
                                />

                                {(gateData?.is_vehicle_oversize && gateData?.is_vehicle_oversize == 1) ? <Container className="mt-2">
                                    <Form.Group className="d-flex">
                                        <input
                                            type="checkbox"
                                            id='is_vehicle_oversize'
                                            name='is_vehicle_oversize'
                                            // {...register('is_vehicle_oversize', {
                                            //     checked: (checkInData?.is_vehicle_oversize == 1) ? true : false,
                                            //     onChange: (e) => handleChange(e)
                                            // }
                                            // )}
                                            checked={true}
                                            disabled={true}
                                            className='me-2'
                                            style={{ 'width': 'auto' }}
                                        />
                                        <Form.Label className='d-flex align-items-center text-secondary fw-bold mb-0 styleLables'>Oversized vehicle?</Form.Label>
                                    </Form.Group>
                                </Container> : null}

                                {/* {/  section for Listing Data /} */}
                                {/* {listData?.length > 0 && <div className="d-block">
                                                <ListingDataComp loader={loader} listData={listData} />
                                            </div>} */}
                                {/* {(priceGreaterOrNot(gateData) && !loader) && <p className='text-primary my-2 fw-semibold py-1 ps-3 bg-primary bg-opacity-10' >Price Breakup</p>} */}
                                <div className="container pt-3 pb-5 overflow-hidden no-ticket-view">
                                    <div className={(!priceGreaterOrNot(gateData) && !loader && !rateLoader) ? 'card shadow rounded-lg receiptCard no-view' : 'card shadow rounded-lg receiptCard'}>
                                        <PaymentBreakUpDetails
                                            breakDownTitle="Price Breakdown"
                                            loader={rateLoader}
                                            isSubmittingForm={false}
                                            className='py-2 d-flex'
                                            isDisplayDetails={true}
                                            paymentData={gateData}
                                            sectionKey={((gateData?.payable_amount != '0.00') && gateData?.payable_amount) ? '' : 'paymantResponse'}
                                            setIsDisplayDetails={setIsDisplayDetails}

                                        />
                                        <div className="card-footer">
                                            {rateLoader ? null : <AmountPaid
                                                className="pb-2 mb-2 d-flex justify-content-between"
                                                paymentData={gateData}
                                                paybleText="Amount to be Paid"
                                                sectionKey={(gateData?.payable_amount) ? '' : 'paymantResponse'}
                                                // isInfo
                                                // isExtendForm
                                                cardInside
                                                hideTaxIncluded={(gateData?.payable_amount > 0 && ((gateData?.tax_fee && gateData?.tax_fee != '0.00') || (gateData?.tax_rate && gateData?.tax_rate != '0.00'))) ? false : true}
                                                setIsDisplayDetails={setIsDisplayDetails}
                                                isTokenApiStarts={isTokenApiStarts}
                                            />}
                                        </div>
                                    </div>
                                </div>
                                {((paymentReciept?.reservation?.ticketech_code && gateData?.is_extended == '0') || ((gateData?.card_type == null || gateData?.card_type == '') && (gateData?.card_last_four == null || gateData?.card_last_four == '' || gateData?.card == null || gateData?.card == '') && (gateData?.payable_amount && Number(gateData?.payable_amount) > 0))) ?
                                    <Form onSubmit={(e) => {
                                        e.preventDefault()
                                        onSubmit()
                                    }}>
                                        {(((gateData?.facility?.facility_configuration?.terms_condition_content && gateData?.facility?.facility_configuration?.terms_condition_content != '') || (partnerDetails?.brand_setting?.terms_condition_content && partnerDetails?.brand_setting?.terms_condition_content != '')) && isPermissionExist(sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions'), 'Display Terms & Conditions Checkbox')) ?
                                            <Col className="m-2">
                                                <Form.Group className="d-flex">
                                                    <input
                                                        type="checkbox"
                                                        id='termsnconds'
                                                        name='termsnconds'
                                                        {...register('termsnconds', {
                                                            required: { value: (((gateData?.facility?.facility_configuration?.terms_condition_content && gateData?.facility?.facility_configuration?.terms_condition_content != '') || (partnerDetails?.brand_setting?.terms_condition_content && partnerDetails?.brand_setting?.terms_condition_content != '')) && isPermissionExist(sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions'), 'Display Terms & Conditions Checkbox')) ? true : false, message: 'Please accept the Terms and Conditions' },
                                                        })}
                                                        className='me-2'
                                                        style={{ 'width': 'auto' }}
                                                        onChange={() => termsChangeHandler()}
                                                    />
                                                    <Form.Label className='d-flex align-items-center text-primary fw-normal mb-0 styleLables'>I have read and agreed to the <span className="fw-bold" onClick={() => { handleScroll() }}>Terms and Conditions</span> <span className='text-danger'>*</span></Form.Label>

                                                </Form.Group>
                                                {errors?.termsnconds && <Form.Text className="text-danger header-s">{errors?.termsnconds?.message}</Form.Text>}
                                            </Col> : null}

                                        {(loginData?.access_token) ? <>
                                            {paybyCardorWallet(ticketDetails, 'card') ? <div className={(gateData?.payable_amount && gateData?.payable_amount != '' && Number(gateData?.payable_amount) > 0 && walletButtonShow && termsAndCondition) ? 'p-4 pb-0' : 'card m-2 paymentCardRadious p-2'}>

                                                <span className='VehilceLables d-flex justify-content-between align-items-start'>Enter Payment Details <span onClick={handlePaymentModal}><i className='fa fa-plus small'></i> Add New Card</span></span>
                                                <ListGroup as="ol" onClick={() => handleCommonListModal()} className='mt-2'>
                                                    <ListGroup.Item as="li" className="ps-1 d-flex justify-content-between align-items-start">
                                                        {/* <Image className='img-10' src={card_top_image} /> */}
                                                        <span style={{ height: '25px', width: '25px' }}>{getSvgIcon('Credit_card', 'var(--bs-primary)')}</span>
                                                        <div className="ms-2 me-auto text-secondary">Payment Method</div>
                                                        {(currentSelCard?.card_last_four) ? <div className='ms-2' style={{ marginTop: '-1px', marginRight: '3px' }}><Image src={getCardIcon(currentSelCard?.card_type)} style={{ height: '1.1rem', 'marginTop': '-0.2rem' }} /> <span className='text-primary fw-semibold me-1' >{currentSelCard?.card_last_four}</span></div> : <i className="fa fa-credit-card mr-2" style={{ marginRight: '0.5rem', marginTop: '4px' }} ></i>}
                                                        <i className='fa fa-caret-down mt-1' style={{ fontSize: '13px' }}></i>
                                                    </ListGroup.Item>
                                                </ListGroup>

                                                {/* <Controller
                                                name='card_id'
                                                id='card_id'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field }) => <Form.Select aria-label="CardSelect" {...field}>
                                                    <option value=''>Please Select</option>
                                                    {cards?.map((item, index) => <option key={index} value={item?.card_holder_id}>{item?.card_last_four}</option>)}
                                                </Form.Select>}
                                            />
                                            {errors?.card_id?.type === 'required' && <Form.Text className="text-danger">This field is required</Form.Text>} */}

                                            </div> : ''}
                                            {returnClockTimer()}
                                            <Row className='mb-4 m-auto w-100 justify-content-center'>
                                                {retunnValidateTicket()}
                                                {(!gateData?.event_id && !gateData?.pass_id && !gateData?.permit_request_id) ?
                                                    <ExtendEndButton
                                                        handleEndParking={handleConfimationModal}
                                                        handleExtend={onSubmit}
                                                        isExtendPrimary
                                                        isEndParking
                                                        isTokenApiStarts={isTokenApiStarts}
                                                        screen={'extend'}
                                                        isFetching={loader}
                                                        wideBtn={true}
                                                        isValidateTicketVisible={isPromoValidateButton(gateData, ['2', '3'], ticketDetails) && (!gateData?.reservation_id || !gateData?.reservation_id === null) && (!gateData?.paid_date)}
                                                        ticketData={gateData}
                                                        setBtnLoader={setBtnLoader}
                                                        btnloader={btnloader}
                                                        paybyCard={paybyCardorWallet(ticketDetails, 'card') || (gateData?.payable_amount && gateData?.payable_amount != '' && Number(gateData?.payable_amount) == 0)}
                                                    /> : null}
                                            </Row>
                                        </> :

                                            <PaymentGateDc
                                                ticketDetails={ticketDetails}
                                                faciltyData={facilityLocData}
                                                isSubmittingForm={isSubmittingForm}
                                                errors={errors}
                                                register={register}
                                                control={control}
                                                onSubmit={handleSubmit(onSubmit)}
                                                isTokenApiStarts={isTokenApiStarts}
                                                isInScreen setFocus={setFocus}
                                                extendBtn={true}
                                                returnClockTimer={returnClockTimer}
                                                retunnValidateTicket={retunnValidateTicket}
                                                restrictedPermission={sortPortalPermissionByKey(partnerdetails, 'Restricted Permissions')}
                                                isPriceZero={isPriceZero}
                                                setCardToken={setCardToken}
                                                multiPaymentWithWallet={(gateData?.payable_amount && gateData?.payable_amount != '' && Number(gateData?.payable_amount) > 0 && walletButtonShow && termsAndCondition)}
                                                paybyCard={paybyCardorWallet(ticketDetails, 'card')}
                                            />

                                        }
                                    </Form> : <>
                                        {returnClockTimer()}
                                        <Row className='mb-2 m-auto w-100 justify-content-center'>
                                            {retunnValidateTicket()}
                                            {(!gateData?.event_id && !gateData?.pass_id && !gateData?.permit_request_id) ?
                                                <div className={`${(isPromoValidateButton(gateData, ['2', '3'], ticketDetails) && (!gateData?.reservation_id || !gateData?.reservation_id === null) && (!gateData?.paid_date) && (gateData?.facility?.is_end_parking != 0 && isExtendButton(gateData?.facility, ['1']))) ? 'col-sm-12' : 'col-sm-12'}`}>
                                                    <ExtendEndButton
                                                        handleEndParking={handleConfimationModal}
                                                        handleExtend={handleExtendSubmit}
                                                        isExtendPrimary
                                                        isTokenApiStarts={isTokenApiStarts}
                                                        screen={'extend'}
                                                        isEndParking
                                                        isFetching={loader}
                                                        wideBtn={true}
                                                        facilityData={gateData?.facility ? gateData?.facility : gateData}
                                                        isValidateTicketVisible={isPromoValidateButton(gateData, ['2', '3'], ticketDetails) && (!gateData?.reservation_id || !gateData?.reservation_id === null) && (!gateData?.paid_date)}
                                                        ticketData={gateData}
                                                        setBtnLoader={setBtnLoader}
                                                        btnloader={btnloader}
                                                        paybyCard={paybyCardorWallet(ticketDetails, 'card') || (gateData?.payable_amount && gateData?.payable_amount != '' && Number(gateData?.payable_amount) == 0) || (!isNaN(gateData?.payable_amount) && Number(gateData?.payable_amount) == 0)}
                                                    />
                                                </div> : null}
                                        </Row>
                                    </>}
                                {(gateData?.payable_amount && gateData?.payable_amount != '' && Number(gateData?.payable_amount) > 0 && walletButtonShow && termsAndCondition && paybyCardorWallet(ticketDetails, 'wallet')) ?
                                    <WalletButtons
                                        faciltyData={gateData}
                                        paybyCard={paybyCardorWallet(ticketDetails, 'card')}
                                        getValues={getValues}
                                        onSubmit={onSubmit}
                                        setIsSubmittingForm={setIsSubmittingForm}
                                        isSubmittingForm={isSubmittingForm}
                                        isIOSDevice={isIOSDevice}
                                        applePaySessionRef={applePaySessionRef}
                                        extend={true}
                                    />
                                    : (gateData?.payable_amount && gateData?.payable_amount != '' && Number(gateData?.payable_amount) > 0 && termsAndCondition && !paybyCardorWallet(ticketDetails, 'card') && paybyCardorWallet(ticketDetails, 'wallet') && !walletButtonShow) ? <div className='container'>
                                        {/* The bellow condition falls if user started payment with apple pay and tries to extend from google pay(another device) and we have off google pay option OR vice verse */}
                                        <p className='alert alert-primary text-center'>{paymentStoppedmsg(isIOSDevice)}</p>
                                    </div> : null}
                                {(gateData?.facility?.facility_configuration?.terms_condition_content && gateData?.facility?.facility_configuration?.terms_condition_content != '') || (partnerDetails?.brand_setting?.terms_condition_content && partnerDetails?.brand_setting?.terms_condition_content != '') ? <div ref={targetRef} className="m-2 p-2 card" dangerouslySetInnerHTML={{ __html: gateData?.facility?.facility_configuration?.terms_condition_content ? gateData?.facility?.facility_configuration?.terms_condition_content : partnerDetails?.brand_setting?.terms_condition_content }} /> : null}
                            </>
                        ) : null
                    : <NoData message={errorMessage?.invalidPartner} />}
            <ScrollCalendar isScrollCalendarModal={isScrollCalendarModal} setIsScrollCalendarModal={setIsScrollCalendarModal} setEntryDateTime={setEntryDateTime} extend={true} entryDateTime={gateData?.checkout_datetime ? gateData?.checkout_datetime : gateData?.checkout_datetime ? gateData?.checkout_datetime : entryDateTime} handleEntryTime={handleEntryTime} setTotalLength={setTotalLength} isDateShow={true} setSeletedRateBand={setRateBandId} hotel_type={updatedFacilityDate?.facility_configuration?.is_facility_hotel_type} partnerdetails={partnerdetails} ticketDetails={gateData} />
            <Footer />
            <PaymentBreakUpDetails
                loader={rateLoader}
                isSubmittingForm={false}
                className="py-2 "
                paymentData={gateData}
                sectionKey={((gateData?.payable_amount != '0.00') && gateData?.payable_amount) ? '' : 'paymantResponse'}
                isDisplayDetails={isDisplayDetails}
                setIsDisplayDetails={setIsDisplayDetails}
            />
            <PaymentModal isPaymentModalOpen={isPaymentModalOpen} setIsPaymentModalOpen={setIsPaymentModalOpen} notify={notify} isInScreen restrictedPermission={sortPortalPermissionByKey(partnerdetails, 'Restricted Permissions')} />
            <CommonListModal setCommonModal={setCommonModal} isCommonModalOpen={isCommonModalOpen} listData={cards} isThisVehicleModal={false} register={register} handleCurrentSelection={handleCurrentSelection} currentSelCard={currentSelCard} />
            <ConfirmationModal
                isConfimationModalOpen={isConfimationModalOpen}
                setIsConfimationModalOpen={setIsConfimationModalOpen}
                finalAction={handleEndParking}
            />

            <ParkingSchModal
                isModalOpen={warningMessageSchdule}
                setIsModalOpen={setWarningPark}
                setIsSubmittingForm={setIsSubmittingForm}
                Message={warningMessage}
                data={hoursOfOper}
                midnighNote={midnighNote}
                isHandleSubmit
                cancelButton={true}
                SubmitButton={false}
                cancelButtonLabel='No'
                SubmitButtonLable='Yes'
                SubmitButtonColor='text-primary'
                handleSubmit={handleSubmitAction}
            />

            <ConfirmationTerms
                setIsSubmittingForm={setIsSubmittingForm}
                isConfimationModalOpen={avalablityAlert}
                setIsConfimationModalOpen={resetFormRates}
                Message={availabilityMessage}
                cancelButton={true}
                cancelButtonLabel='OK'
                cancleButtonColor='text-primary'
            />

            {ratesChanged?.modal && <div className='h-100 w-100 zIndexHigh position-fixed'>
                <div className='h-100 opacity-50 bg-secondary w-100'>

                </div>
                <div className='bg-white p-2 rounded position-fixed top-40 ratesPopup'>
                    <p>{ratesChanged?.msge ? ratesChanged?.msge : errorMessage?.somethingWentWrong}</p>
                    <p className="text-end m-0 p-0">
                        <button
                            type="button"
                            className='btn text-white bg-primary'
                            onClick={() => refreshPage()}
                            disabled={ratesChanged?.loader}
                        ><div className='d-flex justify-content-center align-items-center'>
                                {ratesChanged?.loader ? <><Circles
                                    height="20"
                                    width="20"
                                    style={{ display: 'inline-block' }}
                                    color="var(--bs-white)"
                                    ariaLabel="circles-loading"
                                    visible={true}
                                />&nbsp;</> : ''}
                                <span>Refresh</span>
                            </div></button>
                    </p>
                </div>
            </div>}
        </div>


    )
}

ExtendFormNew.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    isFetching: PropTypes.bool,
    notify: PropTypes.func,
    isFetchingPartner: PropTypes.bool,
    partnerDetails: PropTypes.object,
    cards: PropTypes.array
}

ExtendFormNew.defaulProps = {
    dispatch: noop,
    loader: false,
    isFetching: false,
    notify: noop,
    isFetchingPartner: true,
    partnerDetails: EMPTY_OBJECT,
    cards: EMPTY_ARRAY,
}

function mapStateToProps({ login, transientReducer, userDetailsReducer, PaymentReducer }) {
    return {
        loader: login?.loader,
        isFetching: transientReducer?.isFetching,
        isFetchingPartner: userDetailsReducer?.isFetching,
        cards: PaymentReducer?.data?.data?.payments,
    }
}
export default connect(mapStateToProps)(ExtendFormNew)